const RESTRICTED_CATHRIN_USER_ADMINISTRATORS = {
  PRELIVE: ["dp7k2wn", "dpafivt", "dphmw8j"],
  PROD: ["dpsk19i", "dpfvf27"],
} as const;

function getRestrictedCathrinUserEnvironment(): keyof typeof RESTRICTED_CATHRIN_USER_ADMINISTRATORS {
  return process.env.GSB_INSTANCE_TYPE === "PROD" ? "PROD" : "PRELIVE";
}

/** Server-side check: authorized administrators for the current environment only. */
export function isRestrictedCathrinUserAdministratorForEnvironment(
  grpId: string,
): boolean {
  const environment = getRestrictedCathrinUserEnvironment();
  return (
    RESTRICTED_CATHRIN_USER_ADMINISTRATORS[environment] as readonly string[]
  ).includes(grpId);
}

/** Client-side visibility: union of all known administrators across environments. */
export function isRestrictedCathrinUserAdministrator(grpId: string): boolean {
  return (
    [
      ...RESTRICTED_CATHRIN_USER_ADMINISTRATORS.PRELIVE,
      ...RESTRICTED_CATHRIN_USER_ADMINISTRATORS.PROD,
    ] as readonly string[]
  ).includes(grpId);
}
